import { Tooltip, Typography } from '@mui/material';
import { useRef, useState } from 'react';

type Props = {
  text: string;
  sx?: object;
};

/**
 * Renders text truncated with ellipsis. Shows a tooltip with the full text
 * only when the text is actually overflowing — not on every cell.
 */
export function TruncatedCell({ text, sx }: Props) {
  const ref = useRef<HTMLSpanElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const handleMouseEnter = () => {
    if (ref.current) {
      setIsOverflowing(ref.current.scrollWidth > ref.current.clientWidth);
    }
  };

  return (
    <Tooltip title={isOverflowing ? text : ''} placement="top" disableInteractive>
      <Typography
        ref={ref}
        component="span"
        onMouseEnter={handleMouseEnter}
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          display: 'block',
          ...sx,
        }}
      >
        {text}
      </Typography>
    </Tooltip>
  );
}
